import React, { ReactNode } from 'react'
import cx from 'classnames'
import './container.scss'

import styleProvider from '@quotatisgroup/uikit-public.style-provider'

export type ContainerProps = {
  className?: string
  classes?: string
  children?: ReactNode
  hasBackgroundGradient?: boolean
  hasBackgroundFirstBloc?: boolean
}

const ContainerComponent = ({
  children,
  className,
  classes,
  hasBackgroundGradient = false,
  hasBackgroundFirstBloc = false,
}: ContainerProps) => {
  return (
    <div
      className={cx(
        classes,
        'container',
        {
          backgroundGradient: hasBackgroundGradient,
          backgroundFirstBloc: hasBackgroundFirstBloc,
        },
        className,
      )}
    >
      {children}
    </div>
  )
}

export const Container = styleProvider(ContainerComponent)
